import React from "react";
import { localize } from "redux-i18n";
import { Chart } from "@components";
import type { AbsenceStatistics } from "@modules/shared/reducer/employee-absences/types";

type Props = $Exact<{
  ...PropsFromLocalize,
  data: AbsenceStatistics,
}>;

export class AbsenceStatisticClosingCompliance extends React.Component<Props> {
  get chartData() {
    let res = [];
    res.push([this.props.t("COMPLIANCE"), this.props.t("TYPE")]);
    this.props.data.closingCompliance.forEach(item => res.push([item.description, item.value]));
    return res;
  }

  render() {
    return (
      <Chart
        type="PieChart"
        title={this.props.t("ABSENCE_CLOSING_COMPLIANCE")}
        values={this.chartData}
        options={{ animation: false }}
      />
    );
  }
}

export default localize()(AbsenceStatisticClosingCompliance);
